import type { WeekNumberProps } from 'react-day-picker';

export type CalendarWeekNumberProps = WeekNumberProps;

const CalendarWeekNumber = ({ children, ...props }: CalendarWeekNumberProps) => {
  return (
    <td {...props}>
      <div className="flex size-(--cell-size) items-center justify-center text-center">
        {children}
      </div>
    </td>
  );
};

export default CalendarWeekNumber;
